const components = [
	'header',
	'judianPoint',
	'home',
	'worksheet/index',
	'worksheet/make',
	'worksheet/detail',
	'worksheet/worksheetTab',
	'report/index',
	'report/reportTab',
	'asset/asset',
	'asset/assetChart',
	'monitor/index',
	'monitor/detail',
	'monitor/monitorChart',
	'monitor/tabMonitor',
	'device',
	'mine',
	'topu'
]
var vueComps = []
for(let comp of components){
	var rs = require('./'+comp + '/index.js')
	vueComps.push(rs.default)
}

const install = function(Vue){
	console.log(vueComps)
	vueComps.map(component=>{
		Vue.component(component.name,component);
	});
}

if(typeof window !== 'undefined'&& window.Vue){
	install(window.Vue);
}

export default{
	version:'1.0',
	install,
	vueComps
	
}



// WEBPACK FOOTER //
// ./src/components/index.js